<script lang="ts" setup>
import { Place, PlaceType } from "@/models/place";
import { useSearchFormStore } from "@/stores/search_form";
const route = useRoute();

const placeType = route.path.match(/\/(.*)\/search/)[1];
const routeQuery = computed(() => route.query);

const searchFormStore = useSearchFormStore();
searchFormStore.setPlaceType(placeType);

await useAsyncData(
  "search",
  () => {
    searchFormStore.search(route.query);
  },
  {
    watch: [routeQuery],
  },
);

useHead({
  title: searchFormStore.title,
  meta: [
    { name: "description", content: searchFormStore.description },
    { name: "og:title", content: searchFormStore.title },
    { name: "og:description", content: searchFormStore.description },
    { name: "twitter:title", content: searchFormStore.title },
  ],
});

definePageMeta({
  layout: "default",
});

function paginationUpdated(page) {
  searchFormStore.setPage(page);
  navigateTo(searchFormStore.route);
  window.scrollTo(0, 0);
}

const tab = ref(1);
</script>

<template lang="pug">
v-container
  v-row(
    class="mt-2"
  )
    v-col
      SearchForm(
        :placeType="searchFormStore.placeType"
      )

  v-row(justify="space-around")
    v-col(cols="10")
      h1 {{searchFormStore.title}}
    v-col(v-if="searchFormStore.places")
      span {{searchFormStore.pagination.total_count}} 件
  v-row
    v-col
      v-sheet(
        class="py-8 px-2"
        color="grey-lighten-5"
        rounded
        elevation="1"
      )
        v-row(justify="space-around")
          v-col
            v-tabs(
              :v-model="tab"
              fixed-tabs


              grow
              class="rounded-t-lg"
            )
              v-tab(:value="1" width="50%"): b リスト表示
              MapSearchDevelopingDialog
                template(#dialog-activator="slotProps")
                  v-tab(
                    :value="1"
                    width="50%"
                    v-bind="slotProps"
                  ): b(class="text-grey-lighten-1") 地図表示（開発中）

        v-row(no-gutters)
          v-col(
            cols="12"
            v-for="place in searchFormStore.places"
            :key="place.id"
            class="place-col"
          )
            v-card(
              class="mx-auto"
              outlined
              :href="place.detailPath"
            )
              v-row(no-gutters)
                v-col(class="text-left" cols="12")
                  v-card-title {{place.name }}
                  v-card-subtitle {{ place.fullAddress }}
              v-row(class="place_content")
                v-col(cols="4" class="col-img flex-nowrap")
                  v-img(
                    :src="place.image1.thumb.url"
                    itemprop="image"
                    height="auto"
                  )
                v-col
                  v-row
                    v-col(class="")
                      div.chips
                        v-chip(
                          :key="feature.slug"
                          v-for="feature in place.features"
                          size="small"
                          :class="searchFormStore.placeType"
                        ) {{feature.name}}
                  v-row
                    v-col
                      p.open-hour
                        v-icon(icon="mdi-clock-time-nine-outline" color="#099b8d")
                        span {{place.open_hour_free_text}}
        v-row(
          align="center"
          justify="center"
          v-if="searchFormStore.places"
        )
          v-col(
            class="col-12 col-sm-6 col-md-6"
          )
            v-pagination(
              v-model="searchFormStore.pagination.current_page"
              class="my-4"
              :length="Math.round(searchFormStore.pagination.total_count / searchFormStore.pagination.per_page)"
              @update:model-value="paginationUpdated"
              :total-visible="3"
            )


</template>

<style lang="scss" scoped>
.v-container {
  color: #737373;
  .place-col {
    border-bottom: 0.1rem solid #f6f6f6;
  }

  .v-col {
    h1 {
      font-size: 1.3rem;
    }
  }

  .v-card-title {
    font-weight: 600;
    line-height: normal;
    padding: 0.1rem 1rem;
  }
  .chips {
    margin: 0px;
    font-size: 0.7rem;
  }
  .v-chip {
    margin: 2px;
  }
  .col-img {
    padding: 0.3rem;
  }

  .place_content {
    margin-top: 0px;
  }

  .open-hour {
    font-size: 0.7rem;
    span {
      vertical-align: middle;
    }
  }
}

.v-chip {
  color: white;
  &.dog-run {
    background-color: #2f8859;
  }

  &.dog-cafe {
    background-color: #f4774a;
  }

  &.dog-hotel {
    background-color: #51a3dc;
  }

  &.pet-salon {
    background-color: #f08e9f;
  }

  &.campsite {
    background-color: #f6e75d; // yellow-lighten-3
    color: #212121; // grey-darken-4
  }
}

@media (max-width: 576px) {
  .v-container {
    .v-card-title {
      font-size: 1.1rem;
    }
    .v-card-subtitle {
      font-size: 0.7rem;
    }
    .v-chip.v-chip--size-small {
      font-size: 0.6rem;
    }
  }

  .cate-list .v-img {
    max-width: none;
  }
}
</style>
